'use client'
import React from 'react'
import { Popover } from 'antd'
// import { ReceiptText } from 'lucide-react'
import styles from './styled.module.scss'
import cls from 'classnames'
import { useLocale } from 'core/components/Locale'
import { useHCRouter } from '@/components/HCNextLink'
const Order = () => {
  const t = useLocale()
  const router = useHCRouter()
  const handleNavigation = (item: any) => () => {
    if (item.meta?.auth) {
      router.push(`login`)
      return
    }
    router.push(item.link)
  }
  const orderList = [
    {
      key: 'coinTradeOrder',
      title: '现货订单',
      link: '/orderHome/coinTradeOrder',
      locale: 'coinTrade_header_021',
    },
    {
      key: 'leverOrder',
      title: '杠杆订单',
      link: '/orderHome/leverOrder',
      locale: 'header_061',
    },
    {
      key: 'order',
      title: 'C2C订单',
      link: '/c2c/order',
      locale: 'coinTrade_header_022',
    },
    {
      key: 'contractOrder',
      title: '合约订单',
      link: '/orderHome/contractOrder',
      locale: 'coinTrade_header_023',
    },
    {
      key: 'ledgeBorrowMoneyRecord',
      title: '质押借币订单',
      link: '/orderHome/ledgeBorrowMoneyRecord',
      locale: 'pledg_090',
    },
    {
      key: 'ieoOrder',
      title: 'Start up订单',
      link: '/orderHome/ieoOrder',
      locale: 'new_ieo_001',
    },
    {
      key: 'wealthManagementRecord',
      title: '理财订单',
      link: '/orderHome/wealthManagementRecord',
      locale: 'double_coin_financial_114',
    },
    {
      key: 'transferRecord',
      title: '划转记录',
      link: '/orderHome/transferRecord',
      locale: 'accountCoinTrade_066',
    },
  ]
  const content = (
    <div className={styles.List}>
      <div className="font-bold f20" style={{ padding: '0 0 10px 0' }}>
        {t('header_090')}
      </div>
      {orderList.map((item, index) => (
        <div key={index} className={styles.listItem} onClick={handleNavigation(item)}>
          <div className={cls([styles.leftIcon, styles[item.key]])}></div>
          <div>{t(item.locale)}</div>
          <div></div>
        </div>
      ))}
    </div>
    // <List
    //   header={<div className="font-bold f20">交易订单</div>}
    //   dataSource={orderList}
    //   bordered={false}
    //   split={false}
    //   size="large"
    //   gutter={0}
    //   renderItem={(item) => (
    //     <List.Item className="cursor-pointer c7">
    //         <div className={styles.listItem}>
    //           <div className={cls([styles.leftIcon, styles[item.key]])}></div>
    //           <div>{item.title}</div>
    //           <div></div>
    //         </div>
    //     </List.Item>
    //   )}
    // />
  )
  return (
    <div className={styles.container}>
      <Popover
        content={content}
        getPopupContainer={(node) => node.parentNode as HTMLElement}
        overlayInnerStyle={{ width: 312, height: 518, padding: '28px 24px' }}
        trigger={'hover'}
        overlayClassName={cls(styles.popoverContent)}
      >
        <div className={styles.searchIcon}>
          <i className="iconfont iconzichan-24 f20"></i>
        </div>
        {/*<ReceiptText size={20} />*/}
      </Popover>
    </div>
  )
}

export default Order
